import { render, staticRenderFns } from "./WidgetPassageAncestors.vue?vue&type=template&id=0ab77c23&"
import script from "./WidgetPassageAncestors.vue?vue&type=script&lang=js&"
export * from "./WidgetPassageAncestors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "WidgetPassageAncestors.vue"
export default component.exports